import { Phone, Mail, MapPin } from "lucide-react";

const go = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer({ onJoinCrew }) {
  return (
    <footer className="bg-[#090A0F] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img
                src="/sora-logo.png"
                alt="Sora Event Staffing"
                className="w-9 h-9 rounded-sm object-cover border border-white/10"
              />
              <span className="flex flex-col items-start leading-none">
                <span className="font-display font-bold text-xl tracking-wide text-white">
                  SORA
                </span>
                <span className="font-mono-tactical text-[9px] uppercase tracking-[0.28em] text-sky-500">
                  Event Staffing
                </span>
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
              The frontline of unforgettable experiences. Vetted, insured,
              event-ready staffing for concerts, stadiums, festivals, and brand
              activations — proudly based in Sydney.
            </p>
            <a
              href="tel:+61430941010"
              data-testid="footer-emergency-phone"
              className="mt-6 inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 font-mono-tactical font-semibold transition-colors"
            >
              <Phone className="w-4 h-4" />
              0430 941 010 — 24/7 Rapid Dispatch
            </a>
          </div>

          <div>
            <h3 className="font-mono-tactical text-xs uppercase tracking-widest text-slate-500">
              Navigate
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ["Services", "services"],
                ["Who We Serve", "who-we-serve"],
                ["How It Works", "how-it-works"],
                ["Crew Estimator", "estimator"],
                ["Request Staff", "request"],
              ].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => go(id)}
                    className="text-slate-400 hover:text-sky-400 transition-colors"
                  >
                    {label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  data-testid="footer-link-join-crew"
                  onClick={onJoinCrew}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Join the Crew
                </button>
              </li>
              <li>
                <a
                  href="/admin"
                  data-testid="footer-link-admin"
                  className="text-slate-500 hover:text-sky-400 transition-colors"
                >
                  Admin Login
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono-tactical text-xs uppercase tracking-widest text-slate-500">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-sky-500 shrink-0" />
                <a
                  href="mailto:josephatsora@gmail.com"
                  data-testid="footer-contact-email"
                  className="hover:text-sky-400 transition-colors"
                >
                  josephatsora@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-sky-500 shrink-0 mt-0.5" />
                Sydney HQ — crewing events across Australia
              </li>
            </ul>
          </div>
        </div>

        <p className="font-display mt-14 text-center text-[13vw] md:text-[9vw] leading-none font-extrabold uppercase text-white/[0.04] select-none">
          Sora
        </p>

        <div className="mt-6 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-500">
          <p>© 2026 Sora Event Staffing. All rights reserved.</p>
          <p className="font-mono-tactical uppercase tracking-widest">
            Fully Insured • Payroll, Super & Workers Comp Handled
          </p>
        </div>
      </div>
    </footer>
  );
}
